export enum EPaymentMethods {
  CREDIT_CARD = 'Credit Card',
  CASH = 'Cash',
  GOOGLE_PAY = 'Google Pay',
  APPLE_PAY = 'Apple Pay',
  GIFT_CARD = 'Gift Card',
  CARD_ON_TAB = 'Card on Tab',
}
